<div class="ui active dimmer" *ngIf="visible">
  <div class="ui large text loader">Loading...</div>
</div>
